export enum ImageLoadState {
  Loading = 'loading',
  Failed = 'failed',
  Loaded = 'loaded'
}
